import React from "react";
import {
  Box,
  Typography,
  Link,
  Container,
  IconButton,
  Badge,
  styled,
  Menu,
  MenuItem,
} from "@mui/material";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import PersonIcon from "@mui/icons-material/Person";
import { SouthAfricanRand } from "../../utils/helpers";
import { COLORS } from "../../constants";
import { borderRadius } from "@mui/system";

const IconButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
}));

// Shared menu items configuration (same as mobile)
const menuItems = [
  { text: "HELP", href: "/faq" },
  { text: "ABOUT", href: "/about" },
  { text: "CONTACT", href: "/contact-us" },
  { text: "COMPANY", href: "/team" },
  { text: "TRADESHOW", href: "/tradeshow" },
  {
    text: "MERCHANDISING",
    href: "/merchandising",
    sx: {
      color: COLORS.themeOrange,
    },
  },
  {
    text: "TRADE",
    href: "/trade",
    sx: {
      background: COLORS.themeYellow,
      color: COLORS.themeBlack,
      fontWeight: 600,
      borderRadius: 99,
      px: 4,
      "&:hover": {
        backgroundColor: COLORS.themeRed,
        color: COLORS.white,
      },
    },
  },
];

const DesktopSiteTopbar = ({
  openSavedVehiclesModal,
  totalGarageItems,
  gotoLoginPage,
  gotoRegistrationPage,
  tecfinityAccountNumber,
  tecfinityAccountName,
  tecfinityAvailableCredit,
  accountType,
  performLogout,
  isAuthenticated,
  accountMenuAnchor,
  handleAccountMenuClick,
  handleAccountMenuClose,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: COLORS.themeBlack,
        color: COLORS.white,
      }}
    >
      <Container>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 1.5,
          }}
        >
          {/* Left Side: Menu Links */}
          <Box
            sx={{
              display: "flex",
              gap: "0.875rem",
              fontWeight: 300,
            }}
          >
            {menuItems.map((item, index) => (
              <Link
                key={index}
                href={item.href}
                color="inherit"
                underline="none"
                sx={{
                  fontSize: "0.875rem",
                  fontWeight: 300,
                  textTransform: "uppercase",
                  p: 1, // Optional: nice touch for hover/active state
                  display: "inline-block",
                  transition: "all 0.2s ease",
                  ...(item.sx || {}),
                }}
              >
                {item.text}
              </Link>
            ))}
          </Box>

          {/* Right Side: Garage Icon and Account Menu */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            <IconButtonContainer>
              <IconButton
                edge="end"
                onClick={openSavedVehiclesModal}
                sx={{ mr: 0 }}
              >
                <Badge badgeContent={totalGarageItems} color="error">
                  <DriveEtaIcon
                    sx={{ color: COLORS.white }}
                    fontSize="medium"
                  />
                </Badge>
              </IconButton>
            </IconButtonContainer>

            {isAuthenticated ? (
              <>
                <IconButton
                  onClick={handleAccountMenuClick}
                  sx={{ color: COLORS.white }}
                >
                  <PersonIcon fontSize="medium" />
                </IconButton>
                <Menu
                  anchorEl={accountMenuAnchor}
                  open={Boolean(accountMenuAnchor)}
                  onClose={handleAccountMenuClose}
                  disableScrollLock={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      p: 1,
                      border: `1px solid ${COLORS.border}`,
                      borderRadius: `2px !important`,
                      color: COLORS.white,
                    },
                  }}
                >
                  <Box sx={{ px: 10, py: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: COLORS.darkText,
                        fontWeight: 600,
                      }}
                    >
                      Account Details
                    </Typography>
                  </Box>

                  <MenuItem sx={{ color: COLORS.lightText }}>
                    Acc Type: {accountType} Account
                  </MenuItem>

                  {!!tecfinityAccountName && (
                    <MenuItem sx={{ color: COLORS.darkText }}>
                      Acc Name: {tecfinityAccountName}
                    </MenuItem>
                  )}
                  {!!tecfinityAccountNumber && (
                    <MenuItem sx={{ color: COLORS.darkText }}>
                      Acc No: {tecfinityAccountNumber}
                    </MenuItem>
                  )}
                  {!!tecfinityAvailableCredit && (
                    <MenuItem sx={{ color: COLORS.darkText }}>
                      Credit:{" "}
                      {SouthAfricanRand.format(tecfinityAvailableCredit)}
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={performLogout}
                    sx={{
                      backgroundColor: COLORS.darkText,
                      color: COLORS.white,
                      mt: 2,
                      mx: 2,
                      "&:hover": {
                        backgroundColor: COLORS.themeBlack,
                      },
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Link
                  href="#"
                  onClick={gotoLoginPage}
                  color="inherit"
                  underline="none"
                  sx={{
                    fontSize: "0.875rem",
                    fontWeight: 300,
                  }}
                >
                  LOGIN
                </Link>
                <Box component="span" sx={{ color: "#fff" }}>
                  |
                </Box>
                <Link
                  href="#"
                  onClick={gotoRegistrationPage}
                  color="inherit"
                  underline="none"
                  sx={{
                    fontSize: "0.875rem",
                    fontWeight: 300,
                  }}
                >
                  REGISTER
                </Link>
              </>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default DesktopSiteTopbar;
